import React from "react"

// Components
import AgencyCodesPanelHeader from "./organisationAgencyCodes.panel.header"
import AgencyCodesPanelBody from "./organisationAgencyCodes.panel.body"

const ViewAgencyCode = () => (
  <>
    <AgencyCodesPanelHeader context="open" />
    <AgencyCodesPanelBody />
  </>
)

export default ViewAgencyCode
